<script setup>
import ProductVariantThumb from "~/components/partials/subelements/ProductVariantThumb.vue"

const model = defineModel()

const props = defineProps({
  options: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: 'Opciones',
  },
  helpText: {
    type: String,
    default: '',
  }
})

const internalOptions = ref([])

function onMarkItem(data) {
  model.value = data
}

function getOptionIsSelected(id) {
  return model.value?.id === id
}

watch(() => props.options, () => {
  internalOptions.value = [...props.options].sort((a, b) => a.price - b.price)
}, {immediate: true})

defineExpose({
  open,
})
</script>

<template>
  <div class="flex flex-col gap-4">
    <div>
      <h2 class="text-lg font-bold italic mb-3">{{ props.title }}</h2>
      <ul class="grid grid-cols-12 gap-2">
        <ProductVariantThumb
            v-for="option in internalOptions"
            class="col-span-3"
            :selected="getOptionIsSelected(option.id)"
            :key="option.id"
            :data="option"
            @click="onMarkItem"
        />
      </ul>
    </div>
    <p v-if="props.helpText" class="text-xs font-bold italic text-red-800">{{ props.helpText }}</p>
  </div>
</template>
